import { HashRouter, Routes, Route, BrowserRouter } from "react-router-dom"
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Views/Admin/HomeAdmin/Home';
import Categories from "./Views/Admin/categories/Categories";
import EditeMagasin from "./Views/Admin/magasin/EditeMagasin";
import CreateMagasin from "./Views/Admin/magasin/CreateMagasin";
import AfficheProduit from "./Views/Admin/HomeAdmin/AfficheProduit";
import AjouterProduit from "./Views/Admin/categories/AjouterProduit";
import Historique from "./Views/Admin/historique/Historique";
import { HomeMagasin } from "./Views/Magasin/HomeMagasin/HomeMagasin";
import Connexion from "./Views/Register/Connexion";
import AfficheProduitMagasin from "./Views/Magasin/HomeMagasin/AfficheProduitsMagasin";
import ProduitMagasin from "./Views/Magasin/HomeMagasin/ProduitMagasin";
import ChangeProduitMagasin from "./Views/Magasin/HomeMagasin/ChangeProduitMagasin";
import PanierMagasin from "./Views/Magasin/panierMagasin/PanierMagasin";
import Commercial from "./Views/Magasin/commercial/Commercial";
import AjouterCommercial from "./Views/Magasin/commercial/AjouterCommercial";
import HistoriqueMagasin from "./Views/Magasin/historique/HistoriqueMagasin";
import HistoriqueId from "./Views/Magasin/historique/HistoriqueId";
import AfficheCommercial from "./Views/Magasin/commercial/AfficheCommercial";
import NotificationMagasin from "./Views/Magasin/notification/NotificationMagasin";
import ConfirmeMessage from "./Views/Magasin/notification/ConfirmeMessage";
import Demande from "./Views/Magasin/HomeMagasin/Demande";
import Client from "./Views/Magasin/client/Client";
import AjouterClient from "./Views/Magasin/client/AjouterClient";
import AjouterProduitM from "./Views/Magasin/HomeMagasin/AjouterProduitM";
import Echanger from "./Views/Admin/historique/Echanger";
import Remboureser from "./Views/Admin/historique/Remboureser";
import PanierPrecedent from "./Views/Magasin/panierMagasin/PanierPrecedent";
import Encour from "./Views/Magasin/historique/Encour";
import HomeCommercial from "./Views/Commercial/Home/HomeCommercial";
import AfficheProduitCommercial from "./Views/Commercial/Produit/AfficheProduitCommercial";
import AfficheProduitVisiteur from "./Views/Utilisateure/visiteur/AfficheProduitVisiteur";
import AddArticleService from "./Services/Admin/AddArticleService";
import MessageSuccess from "./Views/Admin/message/MessageSuccess";
import AfficheProduitService from "./Services/Admin/AfficheProduitService";
import ModifierProduit from "./Views/Admin/HomeAdmin/ModifierProduit";
import ModifierArticleService from "./Services/Admin/ModifierArticleService";
import AvisClient from "./Views/Utilisateure/visiteur/AvisClient";
import LoginService from "./Services/Authentication/LoginService";
import HomeClient from "./Views/Utilisateure/client/HomeClient";
import NotificationClient from "./Views/Utilisateure/client/NotificationClient";
import AfficheArticleById from "./Services/Magasin/AfficheArticleById";
import AddCommercialMagasin from "./Services/Magasin/AddCommercialMagasin";
import MessageAddCommercial from "./Views/Admin/message/MessageAddCommercial";
import AddClient from "./Services/Magasin/AddClient";
import MessageAddClient from "./Views/Admin/message/MessagAddClient";
import AddArticle from "./Services/Magasin/AddArticle";
import MessageAddArticleInMagasin from "./Views/Admin/message/MessageAddArticleInMagasin";
import Logout from "./Services/Magasin/Logout";
import AfficheArticleByIdVisiteure from "./Services/Visiteure/AfficheArticleByIdVisiteure";
import CommandeMagasin from "./Views/Magasin/commande/CommandeMagasin";
import CommandeMagasinServiec from "./Services/Magasin/CommandeMagasinService";
import SettingAdmin from "./Views/Admin/Setting/SettingAdmin";
import AssistanceAdmin from "./Views/Admin/Setting/ChatSupport";
import MessageUpdateArticle from "./Views/Admin/message/MessageUpdateArticle";
import Sidebare from "./Views/Admin/Sidbare/Sidebare";
import SettingMagasin from "./Views/Magasin/Setting/SettingMagasin";
import { useState } from "react";
import AllProduit from "./Views/Admin/HomeAdmin/AllProduit";
import AllProduitMagasin from "./Views/Magasin/HomeMagasin/AllProduitMagasin";
import NotificationAdmin from "./Views/Admin/notification/NotificationAdmin";
import NotificationCommercial from "./Views/Commercial/notification/NotificationCommercial";
import DetailCommande from "./Views/Admin/historique/DetailCommande";
import PageNotFound from "./PageNotFound";
import AllProductClient from "./Views/Utilisateure/client/AllProductClient";
import AfficheProduitClientService from "./Services/Visiteure/Client/AfficheProduitClientService";
import ChangePasswordAdmin from "./Views/Admin/Setting/ChangePasswordAdmin";
import ChnageMailAdmin from "./Views/Admin/Setting/ChangeMailAdmin";
import DetailCommandeMagasin from "./Views/Magasin/historique/DetailCommandeMagasin";
import Magasin from "./Views/Admin/magasin/Magasin";

import CommandeCommercialService from "./Services/Commercial/CommandeCommercialServiec";
import AfficheCommandeCommercial from "./Services/Admin/AfficheCommandeCommercial";
import HistoriqueCommercial from "./Views/Admin/historique/HistoriqueCommercial";
import HistoriqueClient from "./Views/Admin/historique/HistoriqueClient";
import CommercialInformation from "./Views/Admin/historique/CommercialInformation";
import HistoriqueCommandeCommercial from "./Views/Commercial/Historique/HistoriqueCommandeCommercial";
import RembourserCommercial from "./Views/Commercial/Historique/RembourserCommercial";
import DetailCommandeCommercial from "./Views/Commercial/Historique/DetailCommandeCommercial";
import HistoriqueCommandeClient from "./Views/Utilisateure/client/Historique/HistoriqueCommandeClient";
import RembourserClient from "./Views/Utilisateure/client/Historique/RembourserClient";
import ClientInformation from "./Views/Admin/historique/ClientInfo";
import AfficheProduitByIdCommercial from "./Views/Commercial/Produit/AfficheProduitByIdCommercial";
import AfficheProduitByIdCommercialService from "./Services/Commercial/AfficheProduitByIdCommercialService";
import AssistanceCommercial from "./Views/Commercial/Setting/AssistanceCommercial";
import AssistanceClient from "./Views/Utilisateure/client/AssistanceClient";
import MesTicketsClient from "./Views/Utilisateure/client/MesTicketsClient";
import CommandeClientService from "./Services/Visiteure/Client/CommandeClientService";
import ChangePasswordCommercial from "./Views/Commercial/Setting/ChangePasswordCommercial";
import ChnageMailCommercial from "./Views/Commercial/Setting/ChangeMailCommercial";
import ChangePasswordClient from "./Views/Utilisateure/client/Setting/ChangePasswordClient";
import ChnageMailClient from "./Views/Utilisateure/client/Setting/ChangeMailClient";
import ChangePasswordMagasin from "./Views/Magasin/Setting/ChangePasswordMagasin";
import ChnageMailMagasin from "./Views/Magasin/Setting/ChangeMailMagasin";
import SettingCommercial from "./Views/Commercial/Setting/SettingCommercial";
import SettingClient from "./Views/Utilisateure/client/Setting/SettingClient";
import PanierCommercial from "./Views/Commercial/panierCommercial/PanierCommercial";
import PanierClient from "./Views/Utilisateure/client/panierClient/panierClient";

import New_page from "./Views/Utilisateure/visiteur/CreateMagasiEnligne";



/* commercial test */
import Commercial_test from "./Views/Admin/commercial-test";
import Allproductvisiteur from "./Views/Utilisateure/visiteur/AllProductVisiteur";
import AllProductVisiteur from "./Views/Utilisateure/visiteur/AllProductVisiteur";

import Panier_visiteur from "./Views/Utilisateure/visiteur/panier-visiteur";
import CreateMagasiEnligne from "./Views/Utilisateure/visiteur/CreateMagasiEnligne";
import AddMagasinenligne from "./Services/Magasin/AddMagasinenligne";
import DemandeAdmin from "./Views/Admin/demande/DemandeAdmin";
import DemandeModificationAdmin from "./Views/Admin/demande/DemandeModificationAdmin";
import ConfirmeDemande from "./Services/Admin/ConfirmeDemande";
import AddMagasin from "./Services/Admin/AddMagasin";
import ModifierClient from "./Views/Magasin/client/ModifierClient";
import TestMaps from "./components/TestMaps";
import EditeMagasinService from "./Services/Admin/EditMagasin";
import FilterByDate from "./Services/Visiteure/Client/FilterByDate";
import HomeVisiteur from "./Views/Utilisateure/visiteur/HomeVisiteur";
import NotFound from "./Views/NotFound";
import ContactNous from "./Views/Utilisateure/visiteur/ContactNous";
import DemandeArticleByRef from "./Services/Magasin/DemandeArticleByRef";
import AfficheArticleByIdVisiteurAvis from "./Services/Visiteure/AfficheArticleByIdVisiteurAvis";
import SideBarMobile from "./Views/Admin/Sidbare/SideBarMobile";
import HomeAdminMobile from "./Views/Admin/mobileAdmin/HomeAdminMobile";
import ConnexionMobil from "./Views/Utilisateure/UtilisateurMobil/ConnexionMobile";
import AllArticleMobile from "./Views/Admin/mobileAdmin/AllArticleMobile";
import ProtectedRoutes from "./components/Protected/ProtectedRoutes";
import ProtectedForMagasin from "./components/Protected/PritectedForMagasin";
import ProtectedAdmin from "./components/Protected/ProtectedAdmin";
import SoapComponent from "./Views/Admin/testapi";
import ArticlesMagasin from "./Views/Magasin/HomeMagasin/ArticlesMagasin";
import RegisterMobile from "./Views/Register/RegisterMobile";
import LoginServiceMobile from "./Services/Authentication/LoginMobile";
import AddMagasinenligneMobile from "./Services/Visiteure/add-magasin-enligne-mobile";
import PanierMagasinMobile from "./Views/Magasin/panierMagasin/PanierMagasinMobile";
import SideBarMagasinMobile from "./Views/Magasin/SideBareMagasin/SidebarMagasinMobile";
import SideBareMagasin from "./Views/Magasin/SideBareMagasin/SideBareMagasin";
import HomeMagasinMobile from "./Views/Magasin/HomeMagasin/mobile-magasin/HomeMagasinMobile";
import CommercialMagasinMobile from "./Views/Magasin/commercial/CommercialMagasinMobile";
import SideBareCommercial from "./Views/Commercial/SideBareCommercial/SideBareCommercial";
import SideBarCommercialMoble from "./Views/Commercial/SideBareCommercial/SideBarCommercialMobile";
import PaymentPopup from "./components/TestMaps";
import ProtectedForVisiteur from "./components/Protected/ProtectedVisiteur";
import CreateAccountVisiteur from "./Views/Utilisateure/visiteur/CreateAccountVisiteur";
import ConnectionVisiteurService from "./Services/Visiteure/ConnectionVisiteur";
import CreateAcoountVisiteurService from "./Services/Visiteure/CreateAcoountVisiteurService";
import DevisHome from "./Views/Admin/Devis/DevisHome";
import ConfirmeCommande from "./Services/Admin/ConfirmeCommande";
import ConfirmerCommandeMagasin from "./Services/Admin/ConfirmerCommandeMagasin";
import CreateDevis from './Views/Magasin/Devis/CreateDevis';
import CreateDevisDirect from './Views/Magasin/Devis/CreateDevisDirect';
import GestionDevis from './Views/Magasin/Devis/GestionDevis';
import DevisEspace from "./Views/Utilisateure/visiteur/EspaceVisiteur/DevisEspace";
import MenuEspace from "./Views/Utilisateure/visiteur/EspaceVisiteur/MenuSpace";
import { HistoriqueEspace } from "./Views/Utilisateure/visiteur/EspaceVisiteur/HistoriqueEspace";
import ProfilEspace from "./Views/Utilisateure/visiteur/EspaceVisiteur/ProfilEspace";
import TicketSystem from "./Views/Admin/Ticket/TicketSystem";
import AdminReclamations from "./Views/Admin/Ticket/AdminReclamations";
import PageErrer from "./Views/Utilisateure/visiteur/PageErreur";
import ConversationTiketsByMagasin from "./Views/Magasin/Tickets/ConversationTiketsByMagasin";
import AllTickets from "./Views/Magasin/Tickets/AllTickets";
import MagasinsEnCompteView from "./Views/Magasin/EnCompte/MagasinsEnCompteView";
import ContactezNous from "./Views/Register/ContactezNous";
import InformationsLegales from "./Views/Register/InformationLegales";
import PolitiquePage from "./Views/Register/PolitiquePage";
import EnvoyeTicket from "./Views/Magasin/Tickets/EnvoyeTicket";
import { NewSideBarAdmin } from "./Views/NewSideBarAdmin";
import TestImage from "./Services/Admin/TestImage";
import { NewSidebareCommercial } from "./Views/NewSideBareCommercial";
import PasswordForget from "./Services/Visiteure/PasswordForget";
import Commission from "./Views/Admin/Commision/Commision";
import GereUtilisateurs from "./Views/Admin/Utilisateurs/GereUtilisateurs";
import PaymentPage from "./Views/Utilisateure/visiteur/PaymentPage";
import Timer from "./components/Timer";
import { NewSideBarMagasins } from "./Views/NewSidebarMagasin";
import DeplaceCommande from "./Views/Magasin/historique/DeplaceCommande";
import DisplayDeplacementArticle from "./Views/Magasin/historique/DisplayDeplacementArticle";
import DisplayAllDeplacement from "./Views/Admin/historique/DisplayAllDeplacment";
import AllTransaction from "./Views/Admin/Transaction/AllTransaction";
import ExpeditionAdmin from "./Views/Admin/Expedition/ExpeditionAdmin";
import SignalerProbleme from "./Views/Utilisateure/visiteur/SignalerProbleme";
import SupportReclamation from "./Views/Utilisateure/visiteur/EspaceVisiteur/SupportReclamation";
import AdminEnCompteTracking from "./Views/Admin/EnCompte/AdminEnCompteTracking";

const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement
);
const MagasinId = localStorage.getItem('MagasinId');
root.render(
      <>
            <BrowserRouter>
                  <Routes>
                        <Route path='/old' index element={<SideBareMagasin />} />
                        <Route path='/new' index element={<NewSidebareCommercial />} />


                        <Route path='/l' index element={<NewSideBarAdmin />} />
                        <Route path='/test' index element={<TestImage />} />

                        <Route path='/magasin/ticket/conversation/:id' index element={<ConversationTiketsByMagasin />} />
                        <Route path='/magasin/envoye/ticket' index element={<EnvoyeTicket />} />

                        <Route path='/informations' index element={<InformationsLegales />} />
                        <Route path='/politique' index element={<PolitiquePage />} />

                        <Route path='/magasins/tickets' index element={<AllTickets />} />
                        <Route path='/contacter-nous' index element={<ContactezNous />} />

                        <Route path='/erreur' index element={<PageErrer />} />
                        <Route path='/signaler-un-probleme' index element={<SignalerProbleme />} />
                        <Route path='/support' index element={<SupportReclamation />} />

{/* -------------------------------- routes authentification -----------------------------*/}
                        <Route path='/visiteur/:id/devis' index element={<DevisEspace />} />
                        <Route path='/visiteur/:id/historiques' index element={<HistoriqueEspace />} />
                        <Route path='/visiteur/:id/profile' index element={<ProfilEspace />} />
                        <Route path='/visiteur/:id/support' index element={<SupportReclamation />} />

                        <Route path='/login' index element={<LoginService />} />
                        <Route path="/espace/:name" element={<LoginService />} />
                        <Route path="/*" element={<NotFound />} />
                        <Route path="/mobile" element={<HomeAdminMobile />} />
                        <Route path="/sd" element={<SideBareCommercial />} />
                        <Route path="/sss" element={<CommercialMagasinMobile />} />
                        <Route path="/transaction" element={<AllTransaction />} />
                        <Route path="/expedition" element={<ExpeditionAdmin />} />

                        <Route path='/testapi' index element={<PaymentPopup />} />


                        <Route path='/magasins/:magasinId/deplace/commande/:commandeId' index element={<DeplaceCommande />} />



                        <Route path="/seconnecter" element={<LoginServiceMobile />} />
                        <Route path="/creer-magasin-enligne" element={<AddMagasinenligneMobile />} />
                        <Route path='/message/commercial' index element={<MessageAddCommercial />} />
                        <Route path='/message' index element={<MessageSuccess />} />
                        <Route path='/message/article' index element={<MessageAddArticleInMagasin />} />
                        <Route path='/message/article/edit' index element={<MessageUpdateArticle />} />
                        <Route path='/message/client' index element={<MessageAddClient />} />
                        <Route path='/créer_compte' index element={<CreateAcoountVisiteurService />} />
                        <Route path='/connecter_compte' index element={<ConnectionVisiteurService />} />
                        <Route path='/commission' index element={<Commission />} />
                        <Route path='/utilisateurs' index element={<GereUtilisateurs />} />

                        {/* <Route path="/s" element={<Sidebare />} /> */}

{/* -------------------------- routes protect (whene you are Registered) --------------------------*/}

                        <Route element ={<ProtectedRoutes/>}>

                              <Route element ={<ProtectedAdmin/>}>

                        
{/* ----------------------------------------- routes Admin --------------------------------------------*/}
                        <Route path='/home' index element={<Home />} />
                        <Route path="/sidebar" element={<Sidebare />} />
                        <Route path='/ticket' index element={<TicketSystem />} />
                        <Route path='/admin/reclamations' index element={<AdminReclamations />} />

                        <Route path='/articles' index element={<AllProduit />} />
                        <Route path='/home/:Namemagasin/articles/:id' element={<AfficheProduitService />} />
                        <Route path='/articles/:ref/edit' element={<ModifierArticleService />} />
                        <Route path='/articles/categories' index element={<Categories />} />
                        <Route path='/articles/categories/add' index element={<AddArticleService />} />
                        <Route path='/magasin' index element={<Magasin/>} />
                        <Route path='/magasin/add' index element={<AddMagasin />} />
                        <Route path='/magasin/:id/edit' index element={<EditeMagasinService />} />
                        <Route path='/magasin/devis' index element={<CreateDevis />} />          
                        <Route path='/magasin/:idmagasin/devis' index element={<CreateDevisDirect />} />
                        <Route path='/deplacement' index element={<DisplayAllDeplacement />} />
                        <Route path='/admin/en-compte' index element={<AdminEnCompteTracking />} />
                        <Route path='/historiques' index element={<Historique />} />
                        <Route path='/devis' index element={<DevisHome />} />

                        <Route path='/Timer' index element={<Timer />} />


                        <Route path='/notification' index element={<NotificationAdmin />} />
                        <Route path='/paramétres' index element={<SettingAdmin />} />
                        <Route path='/paramétres/change-mot-de-passe' index element={<ChangePasswordAdmin />} />
                        <Route path='/paramétres/email' index element={<ChnageMailAdmin />} />
                        <Route path='/assistance' index element={<AssistanceAdmin />} />
                        <Route path='/historiques/:id' index element={<ConfirmeCommande />} />

                        {/* <Route path='/historiques/:id' index element={<DetailCommande />} /> */}
                        <Route path='/historiques/commercials' index element={<HistoriqueCommercial />} />
                        <Route path='/historiques/client' index element={<HistoriqueClient />} />
                        <Route path='/historiques/:id/echanger' index element={<Echanger />} />
                        <Route path='/historiques/:id/rembourser' index element={<Remboureser />} />
                        <Route path='/magasin/:idMag/commercial/:id' index element={<CommercialInformation />} />
                        <Route path='/magasin/:idMag/client/:id' index element={<ClientInformation />} />
                        <Route path='/magasins/:id/clients/:id' index element={<ModifierClient />} />
                        <Route path='/demandes' index element={<DemandeAdmin />} />
                        <Route path='/demandes/modifications' index element={<DemandeModificationAdmin />} />
                        <Route path='/demandes/:id/confirmer' index element={<ConfirmeDemande />} />

                        </Route>

{/* ---------------------------------------- end of routes admin -----------------------------------------------*/}

{/* --------------------------------------- routes magasin -------------------------------------------*/}
<Route path='/magasins/:id/commercials/:commercialId' index element={<AfficheCommercial />} />
<Route path='/magasins/:id/commercials/:id' index element={<AfficheCommercial />} />
<Route path='/magasins/:id/historiques/:id' index element={<ConfirmerCommandeMagasin />} />
<Route path='/magasins/:id/historiques/encour/id' index element={<Encour />} />
                        <Route path='/magasins/:id/deplacement' index element={<DisplayDeplacementArticle />} />

                        <Route path='/magasins/:id/:NameMagasin/articles/:ref' index element={<AfficheArticleById />} />
                              <Route element ={<ProtectedForMagasin/>}>
                          <Route path='/magasins/:id' index element={<HomeMagasin />} />
                          <Route path='/magasins/:id/devis' index element={<CreateDevisDirect />} />
                         <Route path='/magasins/:id/gestion-devis' index element={<GestionDevis />} />
                        <Route path='/magasins/:id/articles' index element={<ProduitMagasin />} />
                        <Route path='/magasins/:id/:magasinName/articles' index element={<ArticlesMagasin />} />

                        {/* <Route path='/magasins/:id/articles' index element={<AllProduitMagasin/>}/> */}
                        <Route path='/magasins/:id/article/:id/edit' index element={<ChangeProduitMagasin />} />
                        <Route path='/magasins/:id/panier' index element={<PanierMagasin />} />
                        <Route path='/magasins/:id/commercials' index element={<Commercial />} />
                        <Route path='/magasins/:id/commercials/add' index element={<AddCommercialMagasin />} />
                        <Route path='/magasins/:id/commercials/:commercialId' index element={<AfficheCommercial />} />
                        <Route path='/magasins/:id/notifications' index element={<NotificationMagasin />} />
                        <Route path='/magasins/:id/notifications/:id/confirme' index element={<ConfirmeMessage />} />
                        <Route path='/magasins/:id/demande/articles/:ref' index element={<DemandeArticleByRef />} />
                        <Route path='/magasins/:id/clients' index element={<Client />} />
                        <Route path='/magasins/:id/clients/add' index element={<AddClient />} />
                        <Route path='/magasins/:id/articles/add' index element={<AddArticle />} />
                        <Route path='/magasins/:id/panier/precedent' index element={<PanierPrecedent />} />
                        <Route path='/magasins/:id/historiques' index element={<HistoriqueMagasin />} />
                        <Route path='/magasins/:id/commande' index element={<CommandeMagasinServiec />} />
                        <Route path='/magasins/:id/en-compte' index element={<MagasinsEnCompteView />} />
                        <Route path='/magasins/:id/paramétres' index element={<SettingMagasin />} />
                        <Route path='/magasins/:id/paramétres/change-mot-de-passe' index element={<ChangePasswordMagasin />} />
                        <Route path='/magasins/:id/paramétres/change-email' index element={<ChnageMailMagasin />} />
                        </Route>
                        <Route path='/logout' index element={<Logout />} />
                        

{/* ---------------------------------------- end of routes magasin -----------------------------------------------*/}

{/* --------------------------------------- routes Commercial ------------------------------------------*/}


                        <Route path='/commercials/:id' index element={<HomeCommercial />} />
                        <Route path='/commercials/:id/articles' index element={<AfficheProduitCommercial />} />
                        <Route path='/commercials/:id/articles/:id' index element={<AfficheProduitByIdCommercialService />} />
                        <Route path='/commercials/:id/notification' index element={<NotificationCommercial />} />
                        <Route path='/commercials/:id/commande' index element={<CommandeCommercialService />} />
                        <Route path='/commercials/:id/historique' index element={<HistoriqueCommandeCommercial />} />
                        <Route path='/commercials/:id/historiques/:orderId/rembourser' index element={<RembourserCommercial />} />
                        <Route path='/commercials/:id/historiques/:orderId' index element={<DetailCommandeCommercial />} />
                        <Route path='/commercials/:id/assistance' index element={<AssistanceCommercial />} />
                        <Route path='/commercials/:id/paramétres' index element={<SettingCommercial />} />
                        <Route path='/commercials/:id/paramétres/change-mot-de-passe' index element={<ChangePasswordCommercial />} />
                        <Route path='/commercials/:id/paramétres/change-email' index element={<ChnageMailCommercial />} />
                        <Route path='/commercials/:id/panier' index element={<PanierCommercial />} />

                        <Route path='/commercials/:id/:NameMagasin/articles/:ref' index element={<AfficheProduitByIdCommercialService />} />


{/* ---------------------------------------- end of routes commercial -----------------------------------------------*/}

{/* ---------------------------------------- routes Client -----------------------------------------------*/}

                        <Route path='/clients/:id' index element={<HomeClient />} />
                        <Route path='/clients/:id/articles/:articleId' index element={<AfficheProduitClientService />} />
                        <Route path='/clients/:id/articles' index element={<AllProductClient />} />
                        <Route path='/clients/:id/articles/:articleId' index element={<AfficheProduitClientService />} />
                        <Route path='/clients/:id/historique' index element={<HistoriqueCommandeClient />} />
                        <Route path='/clients/:id/historique/:orderId/rembourser' index element={<RembourserClient />} />
                        <Route path='/clients/:id/assistance' index element={<AssistanceClient />} />
                        <Route path='/clients/:id/mes-tickets' index element={<MesTicketsClient />} />
                        <Route path='/clients/:id/notification' index element={<NotificationClient />} />
                        <Route path='/clients/:id/commande' index element={<CommandeClientService />} />
                        <Route path='/clients/:id/paramétres' index element={<SettingClient />} />
                        <Route path='/clients/:id/paramétres/change-mot-de-passe' index element={<ChangePasswordClient />} />
                        <Route path='/clients/:id/paramétres/change-email' index element={<ChnageMailClient />} />
                        <Route path='/client/:id/panier' index element={<PanierClient />} />

{/* ---------------------------------------- end of routes client -----------------------------------------------*/}

                        </Route>
{/* ---------------------------------------- end of routes protected -----------------------------------------------*/}

{/* -------------------------------- routes Visiteur -----------------------------*/}

                        <Route path='/' index element={<HomeVisiteur />} />
                        <Route path='/visiteurs' index element={<HomeVisiteur />} />
                        {/* Public visitor routes — no login required to view products */}
                        <Route path='/visiteurs/:maga/articles/:ref' index element={<AfficheArticleByIdVisiteure />} />
                        <Route path='/visiteurs/articles/:ref/avis' element={<AfficheArticleByIdVisiteurAvis />} />
                        <Route path='/visiteurs/articles' index element={<FilterByDate />} />
                        <Route element ={<ProtectedForVisiteur/>}>
                        <Route path='/visiteurs/panier' index element={<Panier_visiteur />} />
                        <Route path='/visiteurs/panier/continue' index element={<PaymentPage />} />
                        <Route path="/visteurs/contactez-nous" element={<ContactNous />} />
                        </Route>
                        <Route path='/mote_de_passe_oublie' index element={<PasswordForget />} />

                        <Route path='/connecte_compte' index element={<AllArticleMobile />} />
                        <Route path='/create-magasin' index element={<AddMagasinenligne />} />


{/* ---------------------------------------- end of routes visiteur -----------------------------------------------*/}

                        {/* {(MagasinId == '' || MagasinId == undefined) ? */}
                              {/* : ""} */}
                        <Route path='/homem' index element={<AllArticleMobile />} />


                        {/* <Route path='/mobile' index element={<SideBarMobile />} /> */}
                       
                        {/* commercial test */}

                        // {/* <Route path='/historiques/:idcommande' index element={<DetailCommande/>}/> */}
                        {/* <Route path='/historiques/:idcommande' index element={<DetailCommande/>}/> */}
                  </Routes>
            </BrowserRouter>
      </>
);